<template>
  <!-- HEADER -->
  <div class="bg-gray-100">
    <div class="max-w-7xl mx-auto py-8 px-4 sm:py-12 sm:px-6 lg:px-8">
      <div class="text-left">
        <!-- <h2 class="text-base font-semibold text-indigo-600 tracking-wide uppercase">Pricing</h2> -->
        <h2
          class="
            text-2xl
            font-extrabold
            tracking-tight
            text-red-600
            sm:text-4xl
          "
        >
          Ceny a dodací lhůty
        </h2>
        <p class="max-w-xl mt-2 mr-auto text-lg sm:text-xl text-gray-500">
          Ceník platný od 1/1/2026
        </p>
      </div>
    </div>
  </div>

  <div class="max-w-7xl pt-14 mx-auto px-4 sm:px-6 lg:px-8">
    <div class="relative overflow-hidden rounded-lg border border-eurozahn-gray/25 bg-white shadow-sm">
      <div class="absolute inset-y-0 left-0 w-1 bg-eurozahn-red"></div>
      <div class="p-4 sm:p-6">
        <h4 class="text-lg md:text-xl font-semibold text-eurozahn-red">
          Nový ceník 2026: Všechny ceny na jednom místě
        </h4>
        <p class="mt-2 text-sm text-gray-600">
          Pro Vaše maximální pohodlí jsme letos <span class="font-bold">sjednotili oba ceníky do jednoho</span>. Samostatný PDF ceník pro klasické otisky již proto nehledejte.
        </p>
        <p class="mt-2 text-sm text-gray-600">
          V tabulce níže snadno najdete obě cenové úrovně – jak pro <span class="font-bold">digitální data (STL)</span>, tak pro <span class="font-bold">klasické otisky</span>.
        </p>
      </div>
    </div>
  </div>
  <!-- ANNOUNCEMENT BOX END -->

  <!-- HEADER END -->
  <div class="max-w-7xl pt-14 mx-auto px-4 sm:px-6 lg:px-8">
    <!-- ANNOUNCEMENT BOX -->

    <!-- TABLE HEADER -->
    <div
      class="
        pb-5
        border-b border-gray-200
        sm:flex sm:items-center sm:justify-between
      "
    >
      <h3
        class="
          text-md
          sm:text-lg
          ml-3
          sm:ml-0
          leading-6
          font-medium
          text-gray-900
        "
      >
        Kompletní ceník zubních náhrad pro rok 2026
      </h3>
    </div>

    <!-- TABLE HEADER END -->
    <!-- Content goes here -->


    <!-- TABLE -->

    <div class="flex flex-col">
      <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
        <div class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
          <div
            class="
              shadow
              overflow-hidden
              border-b border-gray-200
              sm:rounded-lg
            "
          >
            <table class="min-w-full divide-y divide-gray-200">
              <thead class="bg-gray-50">
              <tr>
                <th
                  scope="col"
                  class="
          px-6
          py-1
          sm:py-3
          align-text-top text-left text-xs
          font-medium
          text-gray-500
          uppercase
          tracking-wider
        "
                >
                  Kód
                </th>
                <th
                  scope="col"
                  class="
          px-6
          py-1
          sm:py-3
          align-text-top text-left text-xs
          font-medium
          text-gray-500
          uppercase
          tracking-wider
        "
                >
                  <div class="text-gray-500 min-w-max">Název</div>
                  <div class="text-xs text-gray-400 min-w-max">
                    Podrobnosti
                  </div>
                </th>
                <th
                  scope="col"
                  class="
          px-6
          py-1
          sm:py-3
          align-text-top text-left text-xs
          font-medium
          text-gray-500
          uppercase
          tracking-wider
        "
                >
                  <div>Cena Kč</div>
                  <div>STL DATA</div>
                  <div class="capitalize text-xs text-gray-400">Z OTISKU</div>
                </th>
                <th
                  scope="col"
                  class="
          px-6
          py-1
          sm:py-3
          align-text-top text-left text-xs
          font-medium
          text-gray-500
          uppercase
          tracking-wider
        "
                >
                  <div>Cena €</div>
                  <div>STL DATA</div>
                  <div class="capitalize text-xs text-gray-400">Z OTISKU</div>
                </th>
                <th
                  scope="col"
                  class="
          px-6
          py-1
          sm:py-3
          align-text-top text-left text-xs
          font-medium
          text-gray-500
          uppercase
          tracking-wider
        "
                >
                  <div class="min-w-max">Dodací lhůta</div>
                  <div class="text-xs text-gray-400 min-w-max">Pracovní dny</div>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr
                v-for="(item, itemIdx) in itemList"
                :key="item.code"
                :class="
                    itemIdx % 2 === 0
                      ? 'bg-white hover:bg-red-50'
                      : 'bg-gray-50 hover:bg-red-50'
                  "
              >
                <td
                  v-if="item.type === 'category'"
                  colspan="7"
                  class="
                      px-3
                      py-3
                      whitespace-nowrap
                      text-md
                      font-semibold
                      text-red-600
                    "
                >
                  {{ item.name }}
                </td>
                <td
                  v-if="item.type === 'item'"
                  class="px-6 align-text-top py-3 whitespace-nowrap text-sm text-gray-500"
                >
                  {{ item.code
                  }}<span v-if="item.codeAdd">,{{ item.codeAdd }}</span>
                </td>
                <td
                  v-if="item.type === 'item'"
                  class="
                      px-6
                      py-3
                      whitespace-nowrap
                      text-sm
                      font-medium
                      text-gray-900
                    "
                >
                  <div class="text-sm text-gray-900">{{ item.name }}</div>
                  <div v-if="item.description" class="text-sm text-gray-500">
                    {{ item.description }}
                  </div>
                </td>
                <td
                  v-if="item.type === 'item'"
                  class="px-6 py-3 whitespace-nowrap text-sm text-gray-500"
                >
                  <div v-if="item.price_czk" class="text-sm text-gray-900">{{ formatNumberSmart(item.price_czk) }} Kč</div>
                  <div v-if="item.priplatek_czk" class="text-sm text-gray-500">
                    {{ formatNumberSmart(item.priplatek_czk) }} Kč
                  </div>
                </td>
                <td
                  v-if="item.type === 'item'"
                  class="px-6 py-3 whitespace-nowrap text-sm text-gray-500"
                >
                  <div v-if="item.price_eur" class="text-sm text-gray-900">{{ formatNumberSmart(item.price_eur) }} €</div>
                  <div v-if="item.priplatek_eur" class="text-sm text-gray-500">
                    {{ formatNumberSmart(item.priplatek_eur) }} €
                  </div>
                </td>
                <td
                  v-if="item.type === 'item'"
                  class="px-6 py-3 whitespace-nowrap text-sm text-gray-500"
                >
                  <div>{{ item.leadtime_1 }} {{ item.leadtime_1_note }}</div>
                  <div v-if="item.leadtime_2 || item.leadtime_2_note" class="text-xs text-gray-400">
                    {{ item.leadtime_2 }} {{ item.leadtime_2_note }}
                  </div>
                </td>
                <!-- td class="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                  {{ item.role }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <a href="#" class="text-indigo-600 hover:text-indigo-900">Edit</a>
              </td> -->
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLE END -->
  </div>
  <GalleryOverview />
</template>

<script>
import Papa from 'papaparse'
import GalleryOverview from '@/components/GalleryOverview.vue'

export default {
  components: {
    GalleryOverview,
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      itemList: [],
    }
  },
  methods: {
    formatNumberSmart(value, locale = 'cs-CZ') {
      if (value === null || value === undefined) return '';
      const raw = String(value).trim();
      if (raw === '') return '';
      // Normalize decimal separator just in case CSV uses comma
      const normalized = raw.replace(/\s/g, '').replace(',', '.');

      // If it's not a number, return as-is (keeps leading zeros in codes elsewhere)
      const num = Number(normalized);
      if (Number.isNaN(num)) return raw;

      // If decimal part exists but is all zeros (e.g., "1200.0", "1200.00"), show as integer.
      const hasNonZeroDecimals = /\.\d*[1-9]\d*$/.test(normalized);
      const formatter = new Intl.NumberFormat(locale, {
        minimumFractionDigits: hasNonZeroDecimals ? 2 : 0,
        maximumFractionDigits: hasNonZeroDecimals ? 2 : 0,
      });

      return formatter.format(num);
    },
    loadCSV() {
      const csvFilePath = `${this.publicPath}pricelist_2026.csv`

      // Fetch the CSV file
      fetch(csvFilePath)
        .then((response) => response.text())
        .then((data) => {
          // Parse the CSV data into JSON
          Papa.parse(data, {
            header: true,
            dynamicTyping: false,
            complete: (result) => {
              this.itemList = result.data
            }
          })
        })
        .catch((error) => {
          console.error('Error loading CSV file:', error)
        })
    }
  },
  created() {
    this.loadCSV()
  },
}
</script>
